// src/Pages/PrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children, role, permission }) {

  const token = localStorage.getItem("token");
  const userRole = (localStorage.getItem("role") || "").trim().toLowerCase();

  let permissions = [];
  try {
    permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  } catch {
    permissions = [];
  }

  if (!token) {
    if (role === "parent") return <Navigate to="/parent/login" replace />;
    return <Navigate to="/login" replace />;
  }

  // allow admin and staff
  if (role === "admin" && !["admin","staff"].includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  if (permission && !permissions.includes(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default PrivateRoute;